var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 allocationdetails",
    class: ['row', 'tableFixHead1']
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.tableDataLoader
    },
    on: {
      "update:active": function($event) {
        _vm.tableDataLoader = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-hover table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [(_vm.IsCheckbox) ? _c('th', {
    staticClass: "text-center tableheader sticky-header"
  }, [(_vm.IsCheckbox && _vm.checkboxDisabled) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllCheckbox),
      expression: "selectAllCheckbox"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllCheckbox) ? _vm._i(_vm.selectAllCheckbox, null) > -1 : (_vm.selectAllCheckbox)
    },
    on: {
      "click": _vm.selectAllItems,
      "change": function($event) {
        var $$a = _vm.selectAllCheckbox,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllCheckbox = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllCheckbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllCheckbox = $$c
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.IsCheckbox && !_vm.checkboxDisabled) ? _c('span', [_vm._v("Select")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(col, index) {
    return _c('th', {
      key: index,
      staticClass: "text-center tableheader sticky-header sticky-last"
    }, [_vm._v("\n          " + _vm._s(col.label) + "\n        ")])
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader sticky-header",
    staticStyle: {
      "position": "sticky",
      "background": "#e0ddd9"
    }
  }, [_vm._v("Action")])], 2)]), _vm._v(" "), _c('tbody', [(!_vm.tableDataLoader && !_vm.showTableData.length) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.totalTHCount,
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._l((_vm.showTableData), function(row, index) {
    return _c('tr', {
      key: index
    }, [(_vm.IsCheckbox) ? _c('td', {
      staticClass: "text-center sticky-first"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedItemsOnChild),
        expression: "selectedItemsOnChild"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": row,
        "checked": Array.isArray(_vm.selectedItemsOnChild) ? _vm._i(_vm.selectedItemsOnChild, row) > -1 : (_vm.selectedItemsOnChild)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedItemsOnChild,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedItemsOnChild = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedItemsOnChild = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedItemsOnChild = $$c
          }
        }, function($event) {
          return _vm.selectedItemdata(row)
        }]
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(col, colIndex) {
      return _c('td', {
        key: colIndex,
        staticClass: "text-center"
      }, [(col.label === 'AWB | MPS ID') ? _c('span', [_vm._v("\n              " + _vm._s(row[col.key[0]]) + " "), _c('br'), _vm._v(_vm._s(row[col.key[1]]) + "\n              "), (row[col.key[2]] > 0) ? _c('span', {
        staticStyle: {
          "background": "yellow"
        }
      }, [_c('br'), _vm._v(_vm._s(row[col.key[2]]) + " items\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (col.type === 'text') ? _c('span', [_vm._v(_vm._s(row[col.key]))]) : _vm._e(), _vm._v(" "), (col.type === 'link') ? _c('a', {
        staticClass: "clickable",
        on: {
          "click": function($event) {
            return col.action(row.id)
          }
        }
      }, [_c('u', [_c('font', {
        attrs: {
          "color": "blue"
        }
      }, [_vm._v("View")])], 1)]) : _vm._e(), _vm._v(" "), (col.type === 'button') ? _c('b-button', {
        staticClass: "btn btn-primary",
        staticStyle: {
          "cursor": "pointer",
          "padding": "4px"
        },
        on: {
          "click": function($event) {
            return col.action(row.id)
          }
        }
      }, [(col.btnicon) ? _c('i', {
        class: col.btnicon
      }) : _vm._e(), _vm._v("\n              " + _vm._s(col.btnlabel) + "\n            ")]) : _vm._e()], 1)
    }), _vm._v(" "), _c('td', [_c('basic-select', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "options": _vm.userlist,
        "name": "row.Srid",
        "placeholder": "Select SR",
        "selected-option": row.srItemObj
      },
      on: {
        "select": function($event) {
          return _vm.selectedItemdata($event, row)
        }
      },
      model: {
        value: (row.Srid),
        callback: function($$v) {
          _vm.$set(row, "Srid", $$v)
        },
        expression: "row.Srid"
      }
    })], 1)], 2)
  })], 2)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32ff152b","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/common/AllocationTable.vue
// module id = 1547
// module chunks = 1